import { useCurrentUserDangerously } from '@euler/app/flows/auth/context';
import QrcodeSharingModal from '@euler/app/flows/settings/components/QrcodeSharingModal';
import { useInviteLink } from '@euler/app/flows/settings/functions';
import { useIsWeixinAvailable } from '@euler/functions/useIsWeixinAvailable';
import { onErrorAlert } from '@euler/utils';
import {
  forwardRef,
  memo,
  useCallback,
  useImperativeHandle,
  useState,
} from 'react';
import Toast from 'react-native-root-toast';
import * as WeChat from 'react-native-wechat-lib';

export type InviteModalRef = {
  show: () => void;
};

export const InviteModal = memo(
  forwardRef<InviteModalRef, any>((_, ref) => {
    const [visible, setVisible] = useState(false);
    const { inviteLink, prepareInviteLink } = useInviteLink();
    const profile = useCurrentUserDangerously();
    const isWeixinAvailable = useIsWeixinAvailable();

    useImperativeHandle(ref, () => ({
      show: () => {
        prepareInviteLink()
          .then(result => {
            if (result != null) {
              setVisible(true);
            }
          })
          .catch(() => null);
      },
    }));

    const onClose = useCallback(() => setVisible(false), []);

    const onShareToWeChat = useCallback(async () => {
      if (!inviteLink) return;

      if (!(await WeChat.isWXAppInstalled())) {
        Toast.show('未安装微信', {
          duration: 1000,
          position: Toast.positions.BOTTOM,
        });
        return;
      }
      WeChat.shareWebpage({
        title: '门店新员工注册',
        webpageUrl: inviteLink,
        description: '点击该链接注册成为门店用户，开始使用知车智检!',
        thumbImageUrl: profile.org.logoImgUrl ?? profile.org.iconImgUrl,
      }).catch(onErrorAlert);
    }, [inviteLink, profile.org.iconImgUrl, profile.org.logoImgUrl]);

    return (
      <QrcodeSharingModal
        title="邀请新员工加入门店"
        url={inviteLink ?? ''}
        iconUrl={profile.org.logoImgUrl ?? profile.org.iconImgUrl}
        isVisible={visible}
        onClose={onClose}
        onShareToWechat={isWeixinAvailable ? onShareToWeChat : undefined}
        textForCopy={
          inviteLink
            ? `点击该链接注册成为门店用户，开始使用知车智检! ${inviteLink}`
            : undefined
        }
      />
    );
  }),
);
